import { useContext, useEffect, useState } from "react"
import { UserContext } from "../userContext"
import Spinner, { ToggleSpinner } from "../components/spinner"
import { generateErrorMessage } from "../../methods/generateErrorMessage"
import { fetchResource } from "../../methods/fetchResource"

export default function AddressChangeForm() {
	const baseURL = "https://srcpa.gov"
	const [message, setMessage] = useState("")
	const [address, setAddress] = useState([<p key="0">Loading...</p>])
	const [addressChangeFormURL, setAddressChangeFormURL] = useState(`${baseURL}/address-changing/`)
	const userContext = useContext(UserContext)
	const spinnerId = "spinner"

	useEffect(() => {
		async function fetchData() {
			let parcelMailing = await fetchResource(`/api/parcelMailing?parcelID=${userContext.parcelID}`)

			if (!parcelMailing.success) {
				setAddress("No mailing address found")

				if (parcelMailing.status === 12801) {
					return
				}

				setMessage(generateErrorMessage(parcelMailing.status))
				return
			}

			let address = parcelMailing.result
			address.zip5 = address.zip5.trim()
			address.zip4 = address.zip4.trim()

			let addressParts = []
			let previousMailingAddress = ""

			if (address.address1 !== "") {
				addressParts.push(<p key="1">{address.address1}</p>)

				if (!isNaN(address.address1[0])) {
					previousMailingAddress = address.address1
				}
			}

			if (address.address2 !== "") {
				addressParts.push(<p key="2">{address.address2}</p>)

				if (!isNaN(address.address2[0])) {
					previousMailingAddress = address.address2
				}
			}

			if (address.address3 !== "") {
				addressParts.push(<p key="3">{address.address3}</p>)

				if (!isNaN(address.address3[0])) {
					previousMailingAddress = address.address3
				}
			}

			//final line list
			let finalLine = []
			if (address.city !== "") {
				finalLine.push(address.city)
			}

			if (address.state !== "") {
				finalLine.push(address.state)
			}

			if (address.zip5 !== "") {
				if (address.zip4 !== "") {
					finalLine.push(`${address.zip5}-${address.zip4}`)
				}
				else {
					finalLine.push(address.zip5)
				}
			}

			addressParts.push(<p key="4">{finalLine.join(", ")}</p>)
			let displayParcelID = `${userContext.parcelID.slice(4, 6)}-${userContext.parcelID.slice(3, 4)}${userContext.parcelID.slice(0, 1)}-${userContext.parcelID.slice(1, 3)}-${userContext.parcelID.slice(6, 10)}-${userContext.parcelID.slice(10, 15)}-${userContext.parcelID.slice(15, 19)}`

			setAddress(addressParts)
			setAddressChangeFormURL(`${baseURL}/General/AddressChangeForm?name=${userContext.name}&email=${userContext.email}&parcelID=${displayParcelID}&previousMailing=${previousMailingAddress}&physicalStreet=${userContext.situsAddress}`)
		}

		fetchData()
	}, [])

	async function onContinueButtonClicked() {
		setProcessingVisuals()

		let docusignURL = await fetchResource("/api/docusign", {
			parcelID: userContext.parcelID,
			email: userContext.email,
			name: userContext.name,
			exemptions: userContext.selectedExemptions
		})

		if (!docusignURL.success) {
			setMessageAndHandleThings(generateErrorMessage(docusignURL.status))
			return
		}

		alert(docusignURL.message)

		window.open(docusignURL.result.url, "_self")
	}

	function setProcessingVisuals() {
		document.getElementById("continueButton").disabled = "true"
		document.getElementById("continueButton").style.display = "none"
		document.getElementById("processingNote").style.display = "inline-block"

		ToggleSpinner(spinnerId)

		setMessage("")
		//document.getElementById(spinnerId).scrollIntoView()
	}

	function setMessageAndHandleThings(message) {
		document.getElementById("continueButton").disabled = ""
		document.getElementById("continueButton").style.display = "inline-block"
		document.getElementById("processingNote").style.display = "none"

		ToggleSpinner(spinnerId)

		setMessage(message)
		//document.getElementById("exemptionsMessage").scrollIntoView()
	}

	return (
		<div id="exemptions-portal--address-change-form" className="container">
			<div className="row">
				<div className="col-12">
					<h1 className="h1-style">Mailing Address Check</h1>
					<div className="bg-navy text-light p-3 rounded">
						<div className="bg-navy-dark p-3 rounded">
							<p>
								This is the current mailing address we have on file for you:
							</p>
							<section className="fw-bold border rounded p-3 mb-3" style={{maxWidth: "650px"}}>
								{address}
							</section>
							<p>
								If this is not accurate, please click on
								{" "}
								<a
									href={addressChangeFormURL}
									target="_blank"
									rel="noreferrer noopener"
									className="text-warning"
								>
									this link
								</a>
								{" "}
								and submit the form so we can update it.
							</p>
							<button
								type="button"
								id="continueButton"
								onClick={onContinueButtonClicked}
								className="btn btn-warning"
							>
								Continue to DocuSign
							</button>
							<h2 id="processingNote" className="StartHidden">
								Please wait, this may take a few moments.
							</h2>
						</div>
						<Spinner id={spinnerId} />
						<h2 id="exemptionsMessage" className={`bg-danger text-dark p-3 rounded mt-3 ${message === "" ? "d-none" : ""}`}>
							{message}
						</h2>
					</div>
				</div>
			</div>
		</div>
	)
}